import { useState } from 'react';
import { TextInput, GlobalButton, SelectMultiInput } from '@/components';
import { TaskFilter } from '../interfaces';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  DeleteForever as TrashIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useTaskOptions } from '../hooks';

interface SearchBarProps {
  initialFilter: TaskFilter;
  filter: TaskFilter;
  search: (updatedFilter: TaskFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<TaskFilter>(filter);

  const handleUpdateFilter = (updatedFilter: Partial<TaskFilter>) => {
    setLocalFilter((prev) => ({ ...prev, ...updatedFilter }));
  };

  const resetFilter = () => {
    setLocalFilter(initialFilter);
    search(initialFilter);
  };

  const handleSearch = () => {
    search(localFilter);
  };

  const { methodsOptions, tasksStatuses } = useTaskOptions();

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-sm shadow-xl gap-5'>
      <div style={{ display: 'flex', gap: '10px' }}>
        <TextInput
          name='task-name-search'
          placeholder='Nombre'
          value={localFilter.name}
          onChange={(name) =>
            handleUpdateFilter({
              name: name.toString(),
            })
          }
        />
        <SelectMultiInput
          name='task-statuses-search'
          placeholder='Estado de tarea'
          value={localFilter.statuses}
          options={tasksStatuses}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              statuses: value,
            });
          }}
        />
        <SelectMultiInput
          name='task-methods-search'
          placeholder='Métodos'
          value={localFilter.methods}
          options={methodsOptions}
          onChange={(value) => {
            setLocalFilter({
              ...localFilter,
              methods: value,
            });
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
